import LoginPage from '@/pages/LoginPage/LoginPage';
export default LoginPage;
